import { Award, FileImage } from 'lucide-react'
import type { CertificateTemplate } from '@/types/certificates'
import { imageUrl, imageSrcSet } from '@/lib/images'

/** The look of a platform template without a server render: brand frame, title. */
const PlatformThumb = ({ title }: { title: string }) => (
  <div className="flex h-full w-full items-center justify-center bg-gray-50 p-4">
    <div className="flex h-full w-full flex-col items-center justify-center rounded border-4 border-double border-primary-500 bg-white px-4 text-center">
      <Award className="mb-2 h-6 w-6 text-primary-600" />
      <span className="line-clamp-2 font-serif text-sm font-semibold text-primary-900">{title}</span>
      <span className="mt-2 h-px w-1/2 bg-gray-300" />
    </div>
  </div>
)

/**
 * The thumbnail of a template, the same one in the Templates tab and in the course's
 * template picker. Fill a relatively positioned box with the template's aspect ratio.
 */
export const TemplateThumb = ({ template }: { template: Pick<CertificateTemplate, 'kind' | 'backgroundUrl' | 'title'> }) => {
  if (template.kind === 'IMAGE' && template.backgroundUrl) {
    return <img src={imageUrl(template.backgroundUrl, { w: 480, fit: 'max' }) || undefined} srcSet={imageSrcSet(template.backgroundUrl, { w: 480, fit: 'max' })} alt="" loading="lazy" className="h-full w-full object-cover" />
  }
  if (template.kind === 'IMAGE') {
    return (
      <div className="flex h-full w-full items-center justify-center text-gray-300">
        <FileImage className="h-10 w-10" />
      </div>
    )
  }
  return <PlatformThumb title={template.title} />
}
